import { render } from "./marktitle.vue?vue&type=template&id=2803a76a&scoped=true"
import script from "./marktitle.vue?vue&type=script&lang=js"
export * from "./marktitle.vue?vue&type=script&lang=js"

import "./marktitle.vue?vue&type=style&index=0&id=2803a76a&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2803a76a"]])

export default __exports__